import { RequestApi } from '@helpers';
import { Config } from "@utils";

const getLatestAppBuildDetails = () => {
    return RequestApi.get(`/appConfig/${Config.appKey}`);
};

const getAppInformation = (type) => {
    return RequestApi.get(`/appConfig/information/${type}`);
};

export default {
    getLatestAppBuildDetails,
    getAppInformation
};